const displayDefaultState = {
  show: 0,
  loadingOverlay: {
    status: false,
    text: 'Loading is good for you... Rest more'
  },
  mode: "default"
};

export default (state = displayDefaultState, action) => {
  let tempState = {...state};

  switch (action.type) {
    default:
      return tempState;

    case "SHOW_LOADING_OVERLAY":
      tempState.loadingOverlay.text = action.text;
      tempState.loadingOverlay.status = true;
      return tempState;
    case "HIDE_LOADING_OVERLAY":
      tempState.loadingOverlay.status = false;
      return tempState;
    case "TOGGLE_LOADING_OVERLAY":
      tempState.loadingOverlay.text = action.text;
      tempState.loadingOverlay.status = !tempState.loadingOverlay.status;
      return tempState;

    case "SHOW_ORDER_TYPE":
      tempState.show = action.show;
      return tempState;

    case "CHANGE_MODE":
      if(tempState.mode !== action.mode){
        tempState.mode = action.mode;
      }
      else{
        tempState.mode = "default";
      }
      return tempState;

  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/display.js